/**
 * Main enum of ids for automation tests.
 */
export enum OrderFieldTestIds {
  ACTION_BACK_BUTTON = 'action-back-btn',
  ACTION_NEXT_BUTTON = 'action-next-btn',
  ACTION_FINISH_BUTTON = 'action-finish-btn',
  ACTION_EXIT_BUTTON = 'action-exit-btn',
  ACTION_CANCEL_BUTTON = 'action-cancel-btn',
  ACTION_SUBMIT_BUTTON = 'action-submit-btn',
  ACTION_PLACE_ORDER_BUTTON = 'action-place-order-btn',
  ACTION_VALIDATE_AVAILABILITY_BUTTON = 'validate-availability-btn',
  OPTIONS_BUTTON = 'options-btn',
  VIEW_MORE_BUTTON = 'view-more-btn',
  DISCARD_BUTTON = 'discard-btn',
  ACCEPT_BUTTON = 'accept-btn',
  CANCEL_BUTTON = 'cancel-btn',
  DELETE_BUTTON = 'delete-btn',
  CREATE_PROFILE_BUTTON = 'create-profile-btn',
  CREATE_ORDER_BUTTON = 'create-order-btn',
  CANCEL_CREATE_ORDER_BUTTON = 'cancel-create-order-btn',
  VALIDATE_AVAILABILITY_BUTTON = 'validate-availability-btn',
  DUPLICATE_FOR_MULTIPLE_DAYS_BUTTON = 'duplicate-for-multiple-days-btn',
  SUPPORT_BUTTON = 'support-btn',
  ORDER_BL_NUMBER = 'order-bl-number',
  ACTION_BAR_SUMMARY_BUTTON = 'action-bar-summary-btn',
  ACTION_BAR_CANCEL_BUTTON = 'action-bar-cancel-btn',
  DISCARD_CHANGES_BUTTON = 'discard-changes-btn',
  NEXT_DAY_BUTTON = 'next-day-btn',
  PREVIOUS_DAY_BUTTON = 'previous-day-btn',
  TODAY_DAY_BUTTON = 'today-day-btn',
  DATE_CONTROLS = 'date-controls',
  CLEAR_ALL_FILTERS_BUTTON = 'clear-all-filters-btn',
  UPDATE_ALL_DATA = 'update-all-data',
  UPDATE_ALL_DATA_BUTTON = 'update-all-data-btn',
  SWITCH_TO_CALENDAR_VIEW = 'switch-to-calendar-view',
  SWITCH_TO_LIST_VIEW = 'switch-to-list-view',
  PRODUCT_CARD = 'product-card',
  ADD_PRODUCTS = 'card-add-products',
  TRIP = 'card-trip',
  CONTRACT = 'contract',
  PROVISIONAL_ORDER_SWITCH = 'provisional-order-switch',
  DESTINATION_EMAIL_INPUT = 'destination-email-input',
  DESTINATION_EMAIL_TAG = 'destination-email-tag',
  REMOVE_PRODUCT = 'remove-product',
  ADD_PRODUCT_BUTTON = 'add-product-btn',
  REMOVE_PRODUCT_BUTTON = 'remove-product-btn',
  CANCEL_ORDER_BUTTON = 'cancel-order-btn',
  TIME_NEGOTIATION_BUTTON = 'time-negotation-btn',
  MODIFY_ORDER_BUTTON = 'modify-order-btn',
  REPEAT_ORDER_BUTTON = 'repeat-order-btn',
  ADD_PUMPING_BUTTON = 'add-pumping',
  NEW_ORDER_TITLE = 'new-order-title',
  CONTACT_FIRST_NAME = 'contact-first-name',
  CONTACT_LAST_NAME = 'contact-last-name',
  CONTACT_ROLE = 'contact-role',
  CONTACT_PHONE_COUNTRY_CODE = 'contact-phone-country-code',
  CONTACT_PHONE_NUMBER = 'contact-phone-number',
  CONTACT_PHONE_EXTENSION = 'contact-phone-extension',
  CONTACT_EMAIL = 'contact-email',
  JOBSITE = 'jobsite',
  POINT_OF_DELIVERY = 'point-of-delivery',
  PURCHASE_ORDER = 'purchase-order',
  PAYMENT_TERMS = 'payment-terms',
  RECEIVING_PERSON = 'receiving-person',
  ANTICIPATED_INVOICE = 'anticipated-invoice',
  ADD_NEW_PERSON_LINK = 'add-new-person-link',
  SPECIAL_INSTRUCTION = 'special-instruction',
  QUANTITY = 'quantity',
  LOADS_REMAINS = 'loads-remains',
  DELIVERY_DATE = 'delivery-date',
  DELIVERY_TIME = 'delivery-time',
  TIME_SLOTS_LEFT = 'time-slots-left',
  TIME_SLOTS_CENTER = 'time-slots-center',
  TIME_SLOTS_RIGHT = 'time-slots-right',
  LOCATION_PAGE = 'location-page',
  LOCATION_MAP = 'location-map',
  REMOVE_RECIPE = 'remove-recipe',
  ACCORDION_PRODUCT_BUTTON = 'accordion-product',
  PRODUCT_CATALOG_BUTTON = 'product-catalog-button',
  SEARCH_SELECT_PRODUCT_TYPE = 'search-select-product-type',
  SEARCH_PRODUCT_CODE = 'search-product-code',
  SEARCH_PRODUCT_DESCRIPTION = 'search-product-description',
  PRODUCT_DESCRIPTION = 'product-description',
  CANCEL_REASONS = 'cancel-reasons',
  ADDITIONAL_COMMENTS = 'additional-comments',
  CLOSE_PROJECT_DELETE_DIALOG = 'close-project-delete-dialog',
  CONFIRM_PROJECT_DELETE_DIALOG = 'confirm-project-delete-dialog',
  CLOSE_PROJECT_DIALOG_BUTTON = 'close-project-dialog-btn',
  CONFIRM_PROJECT_DIALOG_BUTTON = 'confirm-project-dialog-btn',
  DELETE_PROJECT_PROFILE = 'delete-project-profile',
  CREATE_PROJECT_PROFILE_BUTTON = 'create-project-profile-btn',
  TERM_CONDITIONS = 'terms-conditions',
  TERM_CONDITIONS_CHECKBOX = 'terms-conditions-checkbox',
}
